import { render, staticRenderFns } from "./ProposalPersonalInfoRouterView.vue?vue&type=template&id=a50564ec&"
import script from "./ProposalPersonalInfoRouterView.vue?vue&type=script&lang=js&"
export * from "./ProposalPersonalInfoRouterView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports